<template>
  <div class="main">
    <div class="sj-cpzx">
      新闻资讯 <span class="en-title">Company News</span>
      <el-divider></el-divider>
    </div>
    <el-card class="news-card" v-for="(item, index) in news" :key="index">
        <div class="news-Img"><el-image :src="item.newsImg" fit="cover" style="width:100%; height:100%; border-radius:10px;"></el-image></div>
        <div class="news-main">
            <a @click="showDetail(item)" class="news-content">
            <span class="news-title">{{item.title}}</span><br>
            <span>{{item.content1}}</span><br>
            <span>{{item.content2}}</span><br>
            <span style="color: #969696;">{{item.time}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.mark}}</span></a>
        </div>
    </el-card><br>
    <el-button class="btn-compNews" @click="getMore" v-loading.fullscreen.lock="Loading" :disabled="btnDisable">{{btnMsg}}</el-button>
    <el-dialog title="资讯详情" :visible.sync="dialogTableVisible" width="1000px" top="30px">
      <iframe :src="htmlContent" width="100%" height="780px" frameborder="no"></iframe>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'news',
  data () {
    return {
      btnDisable: false,
      btnMsg: '查看更多 +',
      Loading: false,
      pageSize: 5,
      pageNum: 1,
      total: 0,
      news: [],
      allNews: [],
      dialogTableVisible: false,
      linkDetailShow: false,
      htmlContent: ''
    }
  },
  mounted () {
    this.$axios.get('/static/news.json').then(res => {
      this.allNews = res.data
      this.total = Math.ceil(this.allNews.length / this.pageSize)
      this.news = this.allNews.splice(0, this.pageSize)
      this.pageNum = this.pageNum + 1
      if (this.pageNum > this.total) {
        this.btnMsg = '没有更多了~'
        this.btnDisable = true
      }
    })
  },
  methods: {
    showDetail (item) {
      this.dialogTableVisible = true
      this.htmlContent = item.url
      if (item.linkUrl) {
        window.open(item.linkUrl)
        this.dialogTableVisible = false
      }
    },
    getMore () {
      this.Loading = true
      let newArr = this.allNews.splice(0, this.pageSize)
      newArr.forEach((item) => {
        this.news.push(item)
      })
      this.pageNum = this.pageNum + 1
      if (this.pageNum > this.total) {
        this.btnMsg = '没有更多了~'
        this.btnDisable = true
      }
      this.Loading = false
    }
  }
}
</script>

<style scoped>
.main{
  width: 100%;
  height: auto;
  min-height: 900px;
  text-align: center;
  margin-top: 10px;
}
.sj-cpzx {
  width: 1800px;
  height: 60px;
  margin-top: 20px;
  text-align: left;
  display: inline-block;
  color: rgba(49, 49, 49, 0.918);
  font-size: 26px;
}
.en-title {
  font-size: 25px;
  color: rgb(149, 158, 158);
}
.news-card {
  width: 1800px;
  text-align: left;
  display: inline-block;
  margin-top: 15px;
}
.news-Img {
  width: 200px;
  height: 120px;
  float: left;
}
.news-main {
  width: 1800px;
  height: 120px;
  margin-left: 220px;
  text-align: left;
  font-size: 16px;
  line-height: 30px;
}
.news-title {
  text-decoration: none;
  color: #000;
  font-weight: 600;
  font-size: 18px
}
.news-content {
  text-decoration: none;
  color: #000;
}
.news-content :hover {
  color: #409EFF;
  cursor: pointer;
}
.btn-compNews {
  width: 400px;
  height: 50px;
  margin-top: 30px;
  margin-bottom: 50px;
  font-size: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue